export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
  }

  build() {
    return `<div class="${this.classes.classes}"
      <wfs-accordions
        ${this.openMultiple()}
        title-classes="${this.classes.titleClasses}"
        id="${this.ids.id}"
      >
        <template v-slot:accordions>
          ${this.accordions()}
        </template>
      </wfs-accordions>
    </div>`
  }

  openMultiple() {
    return this.content.severalOpen ? 'open-multiple' : ''
  }

  accordions() {
    return this.content.sections.map(section => `<wfs-accordion>
      <template v-slot:header>
        <div class="wf-flex wf-items-center">
          ${this.iconSlot()}
          <div>${section.content.title}</div>
        </div>
      </template>
      <template v-slot:content>${section.html}</template>
    </wfs-accordion>`).join('')
  }

  iconSlot() {
    if (! this.content.hasIcon) {
      return ''
    }
    return `<div
      class="wf-flex wf-items-center wf-mr-2 wf-justify-center wf-h-8 wf-w-8 ${this.classes.iconContainerClasses}"
      id="${this.ids.iconContainerId}"
    >
      <i id="${this.ids.iconId}" class="wf-text-sm ${this.content.class} ${this.content.icon}"></i>
    </div>`
  }
}